import { render } from "./EraseDates.vue?vue&type=template&id=4f719498&scoped=true"
import script from "./EraseDates.vue?vue&type=script&lang=js"
export * from "./EraseDates.vue?vue&type=script&lang=js"

import "./EraseDates.vue?vue&type=style&index=0&id=4f719498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f719498"]])

export default __exports__